"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Task", "__struct__", 0, "public", [{params: (context) => [], guards: [], body: (context) => {
return Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Task")], [Type.atom("mfa"), Type.atom("nil")], [Type.atom("owner"), Type.atom("nil")], [Type.atom("pid"), Type.atom("nil")], [Type.atom("ref"), Type.atom("nil")]]);
}}]);

Interpreter.defineElixirFunction("Task", "__struct__", 1, "public", [{params: (context) => [Type.variablePattern("kv_0")], guards: [], body: (context) => {
Interpreter.matchOperator(Elixir_Enum["reduce/3"](context.vars.kv_0, Type.tuple([Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Task")], [Type.atom("mfa"), Type.atom("nil")], [Type.atom("owner"), Type.atom("nil")], [Type.atom("pid"), Type.atom("nil")], [Type.atom("ref"), Type.atom("nil")]]), Type.list([Type.atom("mfa"), Type.atom("owner"), Type.atom("pid"), Type.atom("ref")])]), Type.anonymousFunction(2, [{params: (context) => [Type.tuple([Type.variablePattern("key_1"), Type.variablePattern("val_2")]), Type.tuple([Type.variablePattern("map_3"), Type.variablePattern("keys_4")])], guards: [], body: (context) => {
return Type.tuple([Elixir_Map["merge/2"](context.vars.map_3, Type.map([[context.vars.key_1, context.vars.val_2]])), Elixir_List["delete/2"](context.vars.keys_4, context.vars.key_1)]);
}}], context, "-__struct__/1-fun-0-")), Type.tuple([Type.variablePattern("map_5"), Type.variablePattern("keys_6")]), context);
Interpreter.updateVarsToMatchedValues(context);
return Interpreter.case(context.vars.keys_6, [{match: Type.list([]), guards: [], body: (context) => {
return context.vars.map_5;
}}, {match: Type.matchPlaceholder(), guards: [], body: (context) => {
return Erlang["error/1"](Elixir_ArgumentError["exception/1"](Type.bitstring([Type.bitstringSegment(Type.string("the following keys must also be given when building "), {type: "binary"}), Type.bitstringSegment(Type.string("struct "), {type: "binary"}), Type.bitstringSegment(Elixir_Kernel["inspect/1"](Type.atom("Elixir.Task")), {type: "binary"}), Type.bitstringSegment(Type.string(": "), {type: "binary"}), Type.bitstringSegment(Elixir_Kernel["inspect/1"](context.vars.keys_6), {type: "binary"})])));
}}], context);
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));